import Styles from './index.module.scss'
import React, {useEffect, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import NFTModal from "@/components/NFTModal";
import BuyPowerModal from "@/view/supperzzle/components/buyPowerModal";
import Service from "@/view/supperzzle/service";
import {hideLoading, showLoading} from "@/components/loading";
import {Toast} from "antd-mobile";
import ActivityRules from "@/view/supperzzle/components/ActivityRules";
import qs from "query-string";
import {getUserInfo} from "@/api/projectManager_self";
import {getGemstoreCount} from "@/api/guland";

const Home = () => {
  const fruitType = ['WATERMELON', 'BLUEBERRIES', 'PEACHES', 'ORANGES', 'LEMONS', 'GREEN_APPLES', 'TOMATOES', 'GARLIC', 'PURPLE_RADISH', 'GREEN_RADISH']
  const pageDom = useRef(null);
  const navigate = useNavigate();
  const [data, setData] = useState([])
  const [points, setPoints] = useState(0)
  const [userInfo, setUserInfo] = useState({});
  const [currentFruits, setCurrentFruits] = useState({})
  const [active, setActive] = useState(false)
  const [score, setScore] = useState(0)
  const [gameStart, setGameStart] = useState(false)
  const [seedResult, setSeedResult] = useState({})
  const [isFast, setIsFast] = useState(false)
  const { fromGems } = qs.parse(window.location.search);
  const [gemSTotalCounts, setGemSTotalCounts] = useState(0)
  const queryGemstoreCounts = async () => {
    const res = await getGemstoreCount()
    if (res?.code !== '000000') throw res?.msg
    setGemSTotalCounts(res.data?.gemstonesCount || 0)
  }
  const queryUserInfo = async () => {
    const {code, msg, data} = await getUserInfo();
    if (code !== '000000') throw msg;
    setUserInfo(data)
  }
  useEffect(() => {
    if(fromGems){
      queryUserInfo()
    }
  }, []);
  const gameOver = () => {
    timerRef.current && clearTimeout(timerRef.current);
    setCount(data?.length)
    setCurrentIndex(data?.length -1)
    currentIndexRef.current=data.length -1
    setActive(false)
    setGameStart(false)
  }
  const getInitData = async (loading = false, orderNo= '', type = '') => {
    try {
      if (loading && !orderNo) showLoading();
      if(loading && !orderNo){
        const userInfoRes = await Service.getUserCertificateStatus();
        type === 'first' && Service.getMyWalletAddressService()
      }
      if(fromGems) {
        queryGemstoreCounts()
      }
      const res = await Service.initDateWithNoActive(fromGems ? 2 : 1);
      if (loading  && !orderNo) hideLoading();
      if (res.code !== '000000') throw res.msg;
      setSeedResult(res.data)
      if(orderNo) {
        getGameDate(true, orderNo, res.data.score)
      } else {
        setCurrentFruits(res.data.initialFruitMap)
        setScore(res.data.score)
      }
    } catch (error) {
      console.log('error', error);
      hideLoading();
      Toast.show(error);

    }
  }
  // 针对宝石对对碰购买之前获取最新点数防止事务导致的信息不准
  const getLastScore = async () => {
    try {
      const res = await Service.initDateWithNoActive(2);
      if (res.code !== '000000') throw res.msg;
      setSeedResult(res.data)
      setScore(res.data.score)
    } catch (error) {
      console.log('error', error);
      Toast.show(error);
    }
  }
  const getGameDate = async (loading = false, orderNo = '', res0Score = 0) => {
    if(!orderNo){
      return
    }
    try {
      if(loading) showLoading()
      const res = await Service.getGameDataService({orderId: orderNo})
      if (loading) hideLoading();
      if (res.code !== '000000') throw res.msg;
      window.localStorage.removeItem('buyPowerOrderNo', '')
      setData(res.data)
      console.log(res.data)
      if(res?.data?.length > 0){
        res.data[0]?.fruits && setCurrentFruits(JSON.parse(res.data[0]?.fruits))
        const addTotalPoints = res.data.reduce((acc, item) => acc + item.points, 0)
        if (!fromGems) {
          setScore(res0Score - addTotalPoints)
        }
      }
      setTimeout(() => {setGameStart(true)}, 2000)
    } catch (e) {
      console.log(e);
      hideLoading();
      Toast.show(e);
    }
  }
  useEffect(() => {
    (()=>{
      getInitData(true, '', 'first');
      onDidFocus();
    })()

  }, []);
  const onDidFocus = () => {
    window.JsBridge.addListener().then(() => {
      gameOver()
      const orderNo = window.localStorage.getItem('buyPowerOrderNo')
      if(orderNo){
        setIsFast(false)
        setIsRunning(false)
        setCurrentIndex(0)
        setCount(0)
        Toast.show({
          content: '购买成功',
          afterClose: () => {
            getInitData(true, orderNo)
          }
        })
      } else {
        getInitData(true)
      }
      onDidFocus();
    });
  }
  const callBack = (orderNo) => {
    gameOver()
    if(orderNo){
      setIsFast(false)
      setIsRunning(false)
      setCurrentIndex(0)
      setCount(0)
      Toast.show({
        content: '购买成功',
        afterClose: () => {
          getInitData(true, orderNo)
        }
      })
    } else {
      getInitData(true)
    }
    onDidFocus();
  }
  const onBack = () => {
    if (window.JsBridge.hasWebViewBridge()) {
      window.JsBridge.back();
    } else {
      navigate(-1);
    }
  }
  const onRuleBtnClick = () => {
    const ModalInstance = NFTModal.show({
      content: <ActivityRules onClose={() => ModalInstance?.close()} />,
      getContainer: pageDom.current,
    });
  }

  const handleNavigate = (uri) => {
    if(!uri) {
      return
    }
    if (window.JsBridge.hasWebViewBridge()) {
      window.JsBridge.push("CustomWeb", { uri: `${window.location.origin}${uri}` })
    } else {
      navigate(uri);
    }
  }
  const buyPower = async () => {
    console.log(gameStart)
    if(gameStart){
      return
    }
    const ModalInstance = NFTModal.show({
      content: <BuyPowerModal
        onClose={() => ModalInstance?.close()}
        callBack={callBack}
        navigate={navigate}
        userInfo={userInfo}
        fromGems={fromGems}
        gemSTotalCounts={gemSTotalCounts}
      />,
      getContainer: pageDom.current,
    });
  }
  const [drop, setDrop] = useState(false)
  const [eliminate, setEliminate] = useState(false)
  const [currentIndex, setCurrentIndex] = useState(0); // 当前轮次
  const currentIndexRef = useRef(currentIndex);
  const [count, setCount] = useState(0);
  const [isRunning, setIsRunning] = useState(false);
  const timerRef = useRef(null);
  const [isPressing, setIsPressing] = useState(false);
  const [pressTime, setPressTime] = useState(0);
  const [timer, setTimer] = useState(null);
  const [hasExecuted, setHasExecuted] = useState(false); // 用于标记 handleFast 是否已经执行过
  // 同步currentIndex到ref
  useEffect(() => {
    currentIndexRef.current = currentIndex;
  }, [currentIndex]);
  // 你a函数（handleDrop）
  const handleDrop = async () => {
    if (currentIndexRef.current + 1 >= data.length) return;
    setDrop(true)
    await new Promise(resolve => {
      setTimeout(() => {
        setDrop(false)
        if (currentIndexRef.current === 0) {
          setCurrentFruits(JSON.parse(data[currentIndexRef.current]?.endFruits || '{}'));
        } else {
          setCurrentFruits(JSON.parse(data[currentIndexRef.current + 1]?.fruits || '{}'));
          setCurrentIndex(prev => prev + 1);
        }
        resolve();
      }, 2000);
    });
  };

  const handleixoachu = async () => {
    if (currentIndexRef.current + 1 >= data.length) return;
    setEliminate(true)
    await new Promise(resolve => {
      setTimeout(() => {
        setEliminate(false)
        if (currentIndexRef.current === 0) {
          setCurrentFruits(JSON.parse(data[currentIndexRef.current + 1]?.endFruits));
          setPoints(data[currentIndexRef.current + 1].points);
          setCurrentIndex(prev => prev + 1);
        } else {
          setCurrentFruits(JSON.parse(data[currentIndexRef.current]?.endFruits));
          setPoints(data[currentIndexRef.current].points);
        }
        setActive(true)
        setTimeout(() => {setActive(false)},2000)
        resolve();
      }, 800);
    });
  };

  // 循环控制逻辑
  const executeA = async () => {
    await handleDrop();
    timerRef.current = setTimeout(executeB, 2000); // A结束2秒后执行B
  };

  const executeB = async () => {
    await handleixoachu();
    setCount(prev => {
      const newCount = prev + 1;
      if (newCount < data.length) {
        timerRef.current = setTimeout(executeA, 1500); // B结束2秒后执行A
      } else {
        setIsRunning(false);
        setGameStart(false)
      }
      return newCount;
    });
  };

  // 启动循环
  const start = () => {
    if (!isRunning) {
      setIsRunning(true);
      setCount(0);
      executeA(); // 首次执行A
    }
  };

  // 清理定时器
  useEffect(() => {
    return () => timerRef.current && clearTimeout(timerRef.current);
  }, []);
  useEffect(() => {
    setScore(p => p + points)
  }, [points]);
  useEffect(() => {
    if(gameStart && data?.length > 0) {
      start()
    }
  }, [gameStart, data]);

  // 开始计时
  const startPress = () => {
    if (hasExecuted) return; // 如果已经执行过handleFast，则不再开始计时

    setIsPressing(true);
    setPressTime(0);
    const newTimer = setInterval(() => {
      setPressTime(prev => prev + 100); // 每100ms增加
    }, 100); // 每100ms增加一次

    setTimer(newTimer);
  };

  // 结束计时
  const stopPress = () => {
    if (hasExecuted) return; // 如果已经执行过handleFast，则停止计时

    setIsPressing(false);
    clearInterval(timer);
    setPressTime(0);
  };

  // 每当长按时间超过 3s 时执行 handleFast
  useEffect(() => {
    if (pressTime >= 3000 && !hasExecuted) {
      handleFast(); // 达到 3 秒时执行一次
      clearInterval(timer); // 停止计时
    }
  }, [pressTime, hasExecuted, timer]);
  const handleFast = () => {
    getLastScore()
    gameOver()
    setIsFast(true)
    setGameStart(false)
  }

  return (
    <div className={Styles.supperzzleHome} ref={pageDom}>
      <div className={Styles.back} onClick={onBack}></div>
      <div className={Styles.top_head}></div>
      <div className={Styles.leaf1}>
        <div className={Styles.rule_btn} onClick={onRuleBtnClick}>活动规则</div>
      </div>
      <div className={Styles.leaf2}>
        <div className={Styles.rule_btn} onClick={() => {
          if (fromGems) {
            handleNavigate('/supperzzle/buyPowerRecord?fromGems=true')
          } else {
            handleNavigate('/supperzzle/buyPowerRecord')
          }
        }}>购买记录</div>
      </div>
      <div className={Styles.center_bg}></div>
      <div className={Styles.contentBox}>
        <div className={Styles.btn_shadow}>
          <div className={Styles.btn_bg}>
            <div className={Styles.btn_row}>
              <button className={Styles.button_style} onClick={buyPower}>购买水果</button>
              <button className={Styles.button_style} onClick={() => {
                if(fromGems){
                  handleNavigate(`/supperzzle/exchangeMall/?fromGems=true`)
                } else {
                  handleNavigate(`/supperzzle/exchangeMall/?score=${score}`)
                }
              }}>兑换商城</button>
            </div>
            <div className={Styles.score_row}>
              <div className={Styles.scoreBox}>我的点数：{isFast ? seedResult.score : score}</div>
            </div>
          </div>
        </div>
        <div onTouchStart={startPress} onTouchEnd={stopPress}>
          {isFast ? (
            <div className={Styles.gameContainerNew}>
              {fruitType.map((type, typeIndex) => {
                let imgName = type ? `${type.toLowerCase()}.png` : 'orange.png'
                const newType = type.replace(/^"|"$/g, '')
                const showFruits = seedResult.initialFruitMap?.[newType] ? Array(seedResult.initialFruitMap[newType]).fill(type) : []
                return (
                  <div key={typeIndex} className={Styles.column}>
                    <div className={Styles.topBox}></div>
                    <div className={Styles.bottomBox}>
                      {showFruits.map((item, index) =>{
                        return (
                          <div className={Styles.oneFruitNew} key={index}>
                            <img src={require(`../fruitImg/${imgName}`)} alt="" />
                          </div>
                        )
                      })}
                    </div>
                  </div>
                )
              })}
            </div>
          ) : (
            <div className={Styles.gameContainerNew}>
              {fruitType.map((type, typeIndex) => {
                let imgName = type ? `${type.toLowerCase()}.png` : 'orange.png'
                const newType = type.replace(/^"|"$/g, '')
                // console.log('data?.[currentIndex]===>', currentIndex, data?.[currentIndex])
                const dropFruits = data?.[currentIndex]?.sendFruits && JSON.parse(data?.[currentIndex]?.sendFruits)?.[newType] > 0 ? Array(JSON.parse(data?.[currentIndex]?.sendFruits)[newType]).fill(type) : []
                const showFruits = currentFruits?.[newType] ? Array(currentFruits[newType]).fill(type) : []
                return (
                  <div key={typeIndex} className={Styles.column}>
                    <div className={Styles.topBox}>
                      <div className={drop ? Styles.addCartoon : Styles.dropHide}>
                        {dropFruits.map((addFruit, addFruitIndex) => {
                          return (
                            <div className={Styles.oneFruitNew} key={addFruitIndex}>
                              <img src={require(`../fruitImg/${imgName}`)} alt="" />
                            </div>
                          )
                        })}
                      </div>
                    </div>
                    <div className={Styles.bottomBox}>
                      {showFruits.map((item, index) =>{
                        if(eliminate){
                          imgName = type ? `${type.toLowerCase()}.gif` : 'orange.png'
                          if(showFruits?.length - 1 === index){
                            if(index % 2 === 0){
                              imgName = `${type.toLowerCase()}.png`
                            }
                          }
                        }
                        return (
                          <div className={Styles.oneFruitNew} key={index}>
                            {index > 9 ? <div>+{showFruits?.length -index}</div> : <img src={require(`../fruitImg/${imgName}`)} alt="" />}
                          </div>
                        )
                      })}
                    </div>
                  </div>
                )
              })}
            </div>
          )}
          {!isFast && <div className={`${Styles.move_up_score} ${active ? Styles.animation : Styles.hidePoints}`}>+{points}</div>}
        </div>
      </div>
      {/*<button onClick={handleFast}>快进</button>*/}
      <div className={Styles.bottomLogo}>
        <img src={require('@/assets/img/kangYangNFT/logo_bottom.png')} alt="" />
      </div>
    </div>
  )
}
export default Home